module.exports = __webpack_public_path__ + "static/stvaportal_kreis-bergstrasse_de-layout_set_logo-725ed0143abb34a137743227a220eeea.png";